import React from "react"
import { Row, Col } from "react-bootstrap"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import * as style from "../Supporters.module.css"
import BaeSystems from "./BAE-Logo.svg"

const SilverLevel = () => {
  const data = useStaticQuery(graphql`
    {
    scsWraps: file(relativePath: { eq: "SCSWraps.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      riverClub: file(relativePath: { eq: "river-club-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 100, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      dar: file(relativePath: { eq: "dar-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      infinitySigns: file(relativePath: { eq: "infinity-signs.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      superOneFoods: file(relativePath: { eq: "Super1CircleLogo500x500.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      curtisWright: file(relativePath: { eq: "curtis-wright-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      car: file(relativePath: { eq: "car-logo.png" }) {
        childImageSharp {
          fluid(maxWidth: 250, quality: 80) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <div>
    <hr />
      <div className={style.stickyHeader} style={{ zIndex: 53 }}><h1 className="text-center">Bronze Level Corporate Donors - $5,000+</h1></div>

      <Row className="mb-4">
        <Col lg={6} xl={4} mb={2}>
          <Row style={{ alignItems: "center", height: "100%" }}>
            <Col md={4} className="text-center">
              <a
                href="https://www.baesystems.com/en/home"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={BaeSystems}
                  alt="BAE Systems Logo"
                  style={{ maxWidth: "162px" }}
                />
                <p
                  className="text-center mt-2"
                  style={{ fontSize: "small", color: "gray" }}
                >
                  Click logo to visit partner website.
                </p>
              </a>
            </Col>

            <Col md={8}>
              <h2>BAE Systems</h2>
            </Col>
          </Row>
        </Col>
      
      
        <Col lg={6} xl={4} mb={2}>
          <Row style={{ alignItems: "center", height: "100%" }}>
            <Col md={4} className="text-center">
              <a
                href="https://www.issdar.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.dar.childImageSharp.fluid}
                  aalt="Daughter of the American Revolution Logo"
                  style={{ maxWidth: "162px" }}
                />
                <p
                  className="text-center mt-2"
                  style={{ fontSize: "small", color: "gray" }}
                >
                  Click logo to visit partner website.
                </p>
              </a>
            </Col>

            <Col md={8}>
              <h2>Daughters of the American Revolution</h2>
              <h4>Idaho State Society</h4>
            </Col>
          </Row>
        </Col>
      

      
        <Col lg={6} xl={4} >
          <Row style={{ alignItems: "center", height: "100%" }}>
            <Col md={4} className="text-center">
              <a
                href="https://www.super1foods.net/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.superOneFoods.childImageSharp.fluid}
                  aalt="Super One Foods Logo"
                  style={{ maxWidth: "162px" }}
                />
                <p
                  className="text-center mt-2"
                  style={{ fontSize: "small", color: "gray" }}
                >
                  Click logo to visit partner website.
                </p>
              </a>
            </Col>

            <Col md={8}>
              <h2>Super One Foods</h2>
              <h4>Hayden, Idaho</h4>
            </Col>
          </Row>
        </Col>
      

      
        <Col lg={6} xl={4} mb={2}>
          <Row style={{ alignItems: "center", height: "100%" }}>
            <Col md={4} className="text-center">
              <a
                href="https://curtisswright.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.curtisWright.childImageSharp.fluid}
                  aalt="Curtiss-Wright Logo"
                  style={{ maxWidth: "200px" }}
                />
                <p
                  className="text-center mt-2"
                  style={{ fontSize: "small", color: "gray" }}
                >
                  Click logo to visit partner website.
                </p>
              </a>
            </Col>

            <Col md={8} >
              <h2>Curtiss-Wright</h2>
              <h4>Cheswick, Pennsylvania</h4>
            </Col>
          </Row>
        </Col>
        <Col lg={6} xl={4} mb={2}>
          <Row style={{ alignItems: "center", height: "100%" }}>
            <Col md={4} className="text-center">
              <a
                href="https://www.scswraps.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.scsWraps.childImageSharp.fluid}
                  aalt="SCS Wraps Logo"
                  style={{ maxWidth: "200px" }}
                />
                <p
                  className="text-center mt-2"
                  style={{ fontSize: "small", color: "gray" }}
                >
                  Click logo to visit partner website.
                </p>
              </a>
            </Col>

            <Col md={8}>
              <h2>SCS Wraps</h2>
              <h4>Bozeman, Montana</h4>
            </Col>
          </Row>
        </Col>
        <Col lg={6} xl={4} mb={2}>
          <Row style={{ alignItems: "center", height: "100%" }}>
            <Col md={4} className="text-center">
              <a
                href="https://idahostatecar.weebly.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Img
                  fluid={data.car.childImageSharp.fluid}
                  aalt="SCS Wraps Logo"
                  style={{ maxWidth: "200px" }}
                />
                <p
                  className="text-center mt-2"
                  style={{ fontSize: "small", color: "gray" }}
                >
                  Click logo to visit partner website.
                </p>
              </a>
            </Col>

            <Col md={8}>
              <h2>Children of the American Revolution</h2>
              <h4>Idaho State Society</h4>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default SilverLevel
